interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | string)[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push("start-ellipsis");
  for (let index = start; index <= end; index += 1) {
    pages.push(index);
  }
  if (end < totalPages - 1) pages.push("end-ellipsis");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <div className="flex items-center justify-center gap-1.5 mt-8 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="px-3 h-9 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
        aria-label="上一页"
      >
        上一页
      </button>
      {pages.map((item) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
              item === page
                ? "bg-primary-600 text-background-50 font-semibold"
                : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="w-9 h-9 flex items-center justify-center text-foreground-400">
            …
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="px-3 h-9 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
        aria-label="下一页"
      >
        下一页
      </button>
    </div>
  );
}